module.exports = __webpack_public_path__ + "media/images/close-tag-icon-e86e8d7c1f236b58c8a4209c131be315.png";